var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { useStore } from "effector-react";
import { useSnackbar } from "notistack";
import { $notifications, removeNotification } from "./model";
var displayed = [];
export var Notifier = function () {
    var notifications = useStore($notifications);
    var _a = useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    var storeDisplayed = function (id) {
        displayed = __spreadArray(__spreadArray([], __read(displayed), false), [id], false);
    };
    var removeDisplayed = function (id) {
        displayed = __spreadArray([], __read(displayed.filter(function (key) { return id !== key; })), false);
    };
    React.useEffect(function () {
        notifications.forEach(function (_a) {
            var key = _a.id, message = _a.message, _b = _a.options, options = _b === void 0 ? {} : _b;
            if (displayed.includes(key))
                return;
            enqueueSnackbar(message, __assign(__assign({ key: key }, options), { onClose: function (event, reason, myKey) {
                    if (options.onClose) {
                        options.onClose(event, reason, myKey);
                    }
                }, onExited: function (event, myKey) {
                    removeNotification(myKey);
                    removeDisplayed(myKey);
                } }));
            storeDisplayed(key);
        });
    }, [notifications, closeSnackbar, enqueueSnackbar]);
    return null;
};
